require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-steve-geluso.json") })
        }
      }, "path---blog-author-steve-geluso");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-steve-geluso!./.cache/json/blog-author-steve-geluso.json
// module id = 709
// module chunks = 231608221292675